var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContentLayoutOnly',[_c('div',[_c('h3',{style:({ display: 'inline-block' })},[_vm._v(" "+_vm._s(("" + (_vm.$t('report.title'))))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }